// actions
export const INIT_PENDING_RESERVATIONS_SOURCE = 'INIT_PENDING_RESERVATIONS_SOURCE';
// mutations
// export const SET_PENDING_RESERVATIONS_NUM = 'SET_PENDING_RESERVATIONS_NUM';
export const SET_PENDING_RESERVATIONS_SOURCE = 'SET_PENDING_RESERVATIONS_SOURCE';
export const DECREMENT_RESERVATION_COUNTER = 'DECREMENT_RESERVATION_COUNTER';
